//import { defineAsyncComponent } from "vue";
//import CallToActionWithImage from "./call-to-action-with-image.vue";
//import CallToAction from "./call-to-action.vue";
//import DemoProductList from "./demo-product-list.vue";
//import FavoriteProducts from "./favorite-products.vue";
//import Features from "./features.vue";
import ImageBlock from "./image-block.vue";
import Login from "./login.vue";
import InnoProductInfo from "./innovadis/inno-product-info.vue"; // Innovadis custom: Custom Product INfo
//import PromoText from "./promo-text.vue";
//import RecommendedProducts from "./recommended-products.vue";
//import RelatedProducts from "./related-products.vue";
//import SubscribeForm from "./subscribe-form.vue";
import TextBlock from "./text-block.vue";
import TitleBlock from "./title-block.vue";
import type { Component } from "vue";

import InnoBannerWithProducts from "../innovadis/inno-banner-with-products.vue";
import InnoCode from "../innovadis/inno-code.vue";
//import InnoComponentMirror from "../innovadis/inno-component-mirror.vue";
import InnoContentSlider from "../innovadis/inno-content-slider.vue";
import InnoContentSliderLongTexts from "../innovadis/inno-content-slider-long-texts.vue";
import InnoDownloads from "../innovadis/inno-downloads.vue";
import InnoFaqs from "../innovadis/inno-faqs.vue";
import InnoFiveProducts from "../innovadis/inno-five-products.vue";
import InnoImageLinkList from "../innovadis/inno-image-link-list.vue";
import InnoTextWithImage from "../innovadis/inno-text-with-image.vue";
import InnoUsps from "../innovadis/inno-usps.vue";
import InnoYouTubeVideo from "../innovadis/inno-youtube-video.vue";

//const Slider = defineAsyncComponent(() => import("./slider.vue"));
//const ProductsBlock = defineAsyncComponent(() => import("./products-block.vue"));

export const templateBlocks: { [key: string]: Component } = {
  //"call-to-action-with-image": CallToActionWithImage,
  //"call-to-action": CallToAction,
  //"demo-product-list": DemoProductList,
  // "favorite-products": FavoriteProducts,
  //features: Features,
  image: ImageBlock,
  login: Login,
  "product-info": InnoProductInfo,
  //products: ProductsBlock,
  //"promo-text": PromoText,
  //slider: Slider,
  //"recommended-products": RecommendedProducts,
  //"related-products": RelatedProducts,
  //"subscribe-form": SubscribeForm,
  text: TextBlock,
  title: TitleBlock,

  "inno-banner-with-products": InnoBannerWithProducts,
  "inno-code": InnoCode,
  //"inno-component-mirror": InnoComponentMirror,
  "inno-content-slider": InnoContentSlider,
  "inno-content-slider-long-texts": InnoContentSliderLongTexts,
  "inno-downloads": InnoDownloads,
  "inno-faqs": InnoFaqs,
  "inno-five-products": InnoFiveProducts,
  "inno-image-link-list": InnoImageLinkList,
  "inno-text-with-image": InnoTextWithImage,
  "inno-usps": InnoUsps,
  "inno-youtube-video": InnoYouTubeVideo,
};
